import React from 'react'
import { makeStyles } from '@material-ui/styles'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { useObserver } from 'mobx-react-lite'
import useStore from 'hooks/useStore'
import { format } from 'date-fns'

const useStyles = makeStyles(theme => ({
	message: {
		padding: theme.spacing(1),
		borderBottom: `1px solid ${theme.palette.divider}`,
		'&:last-child': {
			borderBottom: 0,
		},
	},
}))

function Message({ message }) {
	const classes = useStyles()

	return (
		<Box className={classes.message}>
			<Box mb={0.3}>
				{message.content.split('\n').map((item, key) => (
					<Typography key={key} variant="body2">
						{item}
					</Typography>
				))}
			</Box>
			<Box color="text.hint" fontSize="caption.fontSize">
				{format(new Date(message.date), 'HH:mm:ss')}
			</Box>
		</Box>
	)
}

function MessageList() {
	const store = useStore()

	return useObserver(() => (
		<>
			<Box textAlign="center" fontWeight="fontWeightMedium" p={1}>
				{format(store.date, 'yyyy년 MM월 dd일')}의 메시지
			</Box>
			<Box flex="1" overflow="auto">
				{store.messages && store.messages.length > 0 ? (
					store.messages.map(x => <Message key={x.id} message={x} />)
				) : (
					<Box py={4} textAlign="center" color="text.hint">
						메시지가 없습니다.
					</Box>
				)}
			</Box>
		</>
	))
}

export default MessageList
